import React, { useEffect } from "react"
import Container from "@material-ui/core/Container"
import Box from "@material-ui/core/Box"
import { useAnimation } from "framer-motion"
import { useInView } from "react-intersection-observer"
import Animated from "../Animations"
import styles from "./IllicitActivity.title.module.css"

const IllicityActivityTitle = () => {
  const animate = useAnimation()
  const [refView, inView] = useInView({
    threshold: 0.5
  })

  useEffect(() => {
    if (inView) {
      animate.start("show")
    }
  }, [animate, inView])

  return (
    <Container className={styles.container} ref={refView}>
      <Box my={0}>
        <Animated.FromDirection
          from="bottom"
          custom={1}
          delay={0.1}
          duration={1.3}
          animate={animate}
        >
          <div className={styles.title}>Illicit activity</div>
        </Animated.FromDirection>
      </Box>
      <Box my={2} pb={3}>
        <Animated.FromDirection
          from="bottom"
          custom={1}
          delay={0.5}
          duration={1.7}
          animate={animate}
        >
          <div className={styles.subTitle}>
            If not carefully managed, EDZs risk undermining economic growth and sustainable
            development by degrading the environment and serving as venues for money laundering,
            drug and wildlife traffiking, and public corruption.
          </div>
        </Animated.FromDirection>
      </Box>
    </Container>
  )
}

export default IllicityActivityTitle
